(function () {
    let slider = false;

    function initVariants() {
        let variants = document.querySelector('.variants__slides');
        let variantOption = document.querySelector('.variants__navigationElem[data-index="0"]');
        let elems = document.querySelectorAll('.variants__navigationElem');
        let elemsWrapper = document.querySelector('.variants__elems');
        let wariantsMore = document.querySelector('[data-morevariants]');

        if( variants ) {

            slider = tns({
                container: variants,
                items: 1,
                slideBy: 1,
                mode: 'gallery',
                autoplay: false,
                nav: false,
                autoplayButtonOutput: false,
                speed: 800,
                prevButton: false,
                nextButton: false
            });

            initListeners();
            variantOption.classList.add('active');
        }
        if (wariantsMore) {
            wariantsMore.addEventListener('click', function () {
                if (elemsWrapper.classList.contains('variants__elements--limited')) {
                    elemsWrapper.classList.remove('variants__elements--limited');
                }
                this.style.display = 'none';
            });
        }

        // if ( elems.length > 6 && elemsWrapper && !elemsWrapper.classList.contains('showAll') ) {
        //     slider2 = tns({
        //         container: document.querySelector('.variants__elems'),
        //         items: 6,
        //         slideBy: 1,
        //         mode: 'carousel',
        //         autoplay: false,
        //         nav: false,
        //         autoplayButtonOutput: false,
        //         speed: 800,
        //         // prevButton: false,
        //         // nextButton: false,
        //         axis: 'vertical',
        //         loop: false,
        //         controls: true
        //     });
        // }

    }

    function initListeners() {
        let variantsOptions = document.querySelectorAll('#variants .customList-option');
        let navigation = document.querySelectorAll('.variants__navigationElem');

        if (variantsOptions) {
            variantsOptions.forEach(function(option) {
                option.addEventListener('click', function() {
                    let index = this.getAttribute('data-index');
                    setTimeout(function() {
                        changeSlide(index);
                    })
                });
            });

            navigation.forEach(function(item) {
                item.addEventListener('click', function() {
                    let index = this.getAttribute('data-index');
                    setTimeout(function() {
                        changeSlide(index);
                    })
                });
            })
        }
    }

    function changeSlide(index) {
        let activeOption = document.querySelector('.variants__navigationElem.active');
            activeOption.classList.remove('active');

        slider.goTo(index);
        document.querySelector('.variants__navigationElem[data-index="'+ index +'"]').classList.add('active');

    }

    window.addEventListener('load', function () {
        initVariants();
    });

})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/variants.js
// module id = 13
// module chunks = 0